
<template>
  <!--群成员-->
  <div>
    <div class="advanced-form">
      <div class="card">
        <div class="card-head">
          <h3>{{`${$route.query.name}（${$route.query.type}）`}}</h3>
        </div>
        <div class="card-body">
          <x-tabula
            apiOrigin="PHP"
            ref="table"
            :dataSource="dataSource"
            :columns="columns"
            rowKey="chat_user_id"
            :searchList="searchList"
            :rowOptList="rowOptList"
            :listApi="listApi"
            :searchParams.sync="searchParams"
            :deleteParam="deleteParam"
            :rowSelection="false"
          >
          </x-tabula>
        </div>
      </div>
    </div>

    <!--禁言的弹窗-->
    <a-modal
      title="禁言"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
    >
      <a-form :form="modalForm">
        <a-form-item label="" :wrapper-col="{ span: 14, offset: 6}">
          <a-icon type="exclamation-circle" />
          <span> 禁言后，此用户无法在当前群聊发言</span>
        </a-form-item>

        <a-form-item label="请选择禁言原因" has-feedback v-bind="$store.state.modal_ItemLayout">
          <a-select
            v-decorator="['chat_category_id',
              {rules: [{ required: true, message: '请选择禁言原因'}]}
            ]"
            allowClear
            showSearch
            :filterOption="filterOption"
            placeholder="请选择禁言原因">
            <a-select-option v-for="(el, order) of reasonList" :key="order" :value="el.value">
              {{el.label}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="截止时间" v-bind="$store.state.modal_ItemLayout">
          <a-input
            v-decorator="['end_time', this.endTime()]"
            placeholder="请输入分钟，不超过43200分钟"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { expireTime } from '@/utils/mixins';
import { inputSearch } from 'ant-design-vue-admin-x';
export default {
  name: 'chatMember',
  mixins: [inputSearch, expireTime],
  data () {
    return {
      chatGroupId: '',
      userId: '',
      visible: false,
      btnLoading: {loading: false},

      /** table 参数 */
      searchParams: {
        keywords: undefined,
        user_type: undefined,
        status: undefined,
        create_date: undefined
      },
      searchList: [
        { props: ['keywords'], placeholder: '用户昵称、群内昵称', options: [], inputType: 'input' },
        { props: ['user_type'], placeholder: '用户类型', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '群内状态', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      rowOptList: [
        {
          text: '禁言',
          handle: record => this.showModal(record),
          rowOptDisHandle: this.banDisable,
          key: 'ban'
        }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '群内昵称', dataIndex: 'group_nick_name', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'user_type_desc', align: 'left', width: '' },
        { title: '群内状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '进群时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: `/chat/group/user/${this.$route.query.id}`,
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '',
        param: { pk_key: '', pk_val: '' },
        title: '',
        key: ''
      },
      reasonList: []
    };
  },
  beforeCreate () {
    this.modalForm = this.$form.createForm(this);
  },
  created () {
    this.chatGroupId = this.$route.query.id;
    this.getSelect();
  },
  methods: {
    /** 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/group/selectlist',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.user_type;
        this.searchList[2].options = data.group_status;
      });
    },
    /** 验证截止时间 */
    validateEndTime (rules, value, callback) {
      value = parseInt(value);
      if (value <= 0) {
        callback(new Error('截止时间需大于0'));
      } else if (value > 43200) {
        callback(new Error('截止时间不大于43200'));
      } else {
        callback();
      }
    },
    /** 判断禁言禁用状态 */
    banDisable (record) {
      if (record.status === 0) {
        return true;
      }
    },
    /* 打开弹窗 */
    showModal (row) {
      this.userId = row.chat_user_id;
      this._get({
        url: '/chat/forbidden/selectlist',
        params: { type: 1 }
      }).then(({data}) => {
        this.reasonList = data.category;
      });
      this.visible = true;
    },
    /** 提交禁言 */
    handleSubmit () {
      this.modalForm.validateFields((error, values) => {
        if (error) { return; }
        this._post({
          url: '/chat/group/user/change',
          params: {
            chat_group_id: this.chatGroupId,
            chat_user_id: this.userId,
            status: 0,
            ...values
          },
          btnLoading: this.btnLoading
        }).then((res) => {
          this.visible = false;
          this.$message.success('禁言成功');
          this.$refs.table.getTableList();
        });
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
